import { useApiRead } from "source/shared/SessionApiResource"

export function usePersonFinder(id) {
  return useApiRead(
    `/people/v2/directory_people/${id}?include=directory_households.directory_people,emails,addresses,phone_numbers`,
  )
}
